package co.maytes.standupbot.dashboard.components.widgets

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.classNames
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.styleModifier

@Composable
fun StretchCard(
    modifier: Modifier = Modifier,
    surfaceClass: String = "sb-surface",
    content: @Composable () -> Unit,
) {
    Card(
        modifier = Modifier
            .classNames(surfaceClass)
            .fillMaxWidth()
            .styleModifier {
                property("display", "flex")
                property("flex-direction", "column")
                property("height", "100%")
            }
            .then(modifier),
    ) {
        content()
    }
}
